// проверка на валидность номера телефона и email
const mobilePhoneRegexp = /^(\+?7)9\d{9}$/;
const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
const removeNonDigits = (str) => str.replace(/\D+/g, '');
const isMobilePhone = (str) => {
    return str ? mobilePhoneRegexp.test('+'+removeNonDigits(str)) : false;
};
const isEmailValid = (str) => {
    return emailRegex.test(str);
};

export {isMobilePhone, isEmailValid, removeNonDigits}